import { useState, useEffect } from 'react';
import { reduce } from 'lodash';

export function usePageData(request, cache = 'default', { ...rest }) {
  const [hasError, setErrors] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({});
  const [blocks, setBlocks] = useState([]);

  function reducer(result, value, key) {
    if (value.blockName === null) {
      return result;
    }

    const block = {
      blockName: value.blockName,
      innerBlocks: reduce(value.innerBlocks, reducer, []),
      attributes: value.attrs.data ?? value.attrs,
      rendered: value.rendered,
    };

    result.push(block);

    return result;
  }

  async function fetchData() {
    const res = await fetch(request, {
      method: 'GET',
      mode: 'cors',
      cache: cache,
    });
    res
      .json()
      .then(res => {
        setData(res);
        setLoaded(true);
        return res;
      })
      .then(res => res.bda_gutenberg_blocks)
      .then(res => reduce(res, reducer, []))
      .then(res => setBlocks(res))
      .catch(err => {
        setErrors(err);
        setLoaded(true);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return [data, blocks, loaded, hasError];
}
